export default __webpack_public_path__ + "static/media/project-1.abecd902.jpg";